import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@mdi/react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { defineStyle } from '../../theme';
export const defaultFilterButtonStyle = defineStyle({
    py: 0.5,
    px: 1.25,
});
export const FilterButton = ({ tooltip, disabled, text, variant, size, color, icon, type, onClick, sxAdditions, }) => {
    const style = useMemo(() => ({ ...defaultFilterButtonStyle, ...(sxAdditions ?? {}) }), [sxAdditions]);
    const tooltipElement = useMemo(() => (tooltip ? _jsx(FormattedMessage, { ...tooltip }) : null), [tooltip]);
    const content = useMemo(() => (text ? _jsx(FormattedMessage, { ...text }) : null), [text]);
    return (_jsx(Tooltip, { title: tooltipElement, children: _jsx("span", { children: _jsx(Button, { variant: variant ?? 'outlined', size: size, color: color, sx: style, disabled: disabled, startIcon: _jsx(Icon, { path: icon, size: 0.8 }), onClick: onClick, type: type, children: _jsx(Typography, { variant: "subtitle2", children: content }) }) }) }));
};
//# sourceMappingURL=FilterButton.js.map